var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggregation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aggregation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.333h-16v2.667l8.667 8-8.667 8v2.667h16v-4h-9.333l6.667-6.667-6.667-6.667h9.333v-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregation);
export default __webpack_public_path__ + "static/media/aggregation.df2c9f024efa548f803e991eeb2e6b3b.svg";
export { ForwardRef as ReactComponent };